// extracted by mini-css-extract-plugin
module.exports = {"root":"VacanciesSiteLink_root__k1MW1","white":"VacanciesSiteLink_white__P2RWm","blue":"VacanciesSiteLink_blue__TnCEk"};